import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home/home";
import Header from "./Home/header";
import Footer from "./Home/footer";
import Checkout from "./checkout/checkout";
import Thankyou from "./ThankyouPage/Thankyou";
import PaypalTest from "./testPypal";
import Contactus from "./contactus/contactus";
import Panel from "./adminPanel/panel";
import Login from "./adminPanel/login";
import Terms from "./aboutpages/Terms";
import About from "./aboutpages/About";
import Faq from "./aboutpages/faq";
import Refund from "./aboutpages/refund";
import  TestPaypal from "./testPypal"
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Home />} path="/"></Route>
          <Route element={<Checkout />} path="/Checkout/:id"></Route>
          <Route element={<PaypalTest />} path="/Paypal"></Route>
          <Route element={<Thankyou />} path="/Thankyou"></Route>
          <Route element={<Contactus />} path="/Contactus"></Route>
          <Route element={<Panel />} path="/panel"></Route>
          <Route element={<Login />} path="/Login"></Route>
          <Route element={<Terms />} path="/Terms"></Route>
          <Route element={<About />} path="/About"></Route>
          <Route element={<Refund />} path="/refund"></Route>
          <Route element={<Faq />} path="/FAQ"></Route>
                    <Route element={<TestPaypal />} path="/TestPaypal"></Route>

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
